import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationMS from './locales/ms.json';
import translationEN from './locales/en.json';

// Translation resources
const resources = {
  ms: {
    translation: translationMS
  },
  en: {
    translation: translationEN
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'ms', // default language (Bahasa Malaysia)
    fallbackLng: 'ms', // fallback language
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
